import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import { Check } from "lucide-react";

export default function Pricing() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen text-black bg-gray-100">
      <Navbar />
      <main className="container px-4 py-12 mx-auto">
        <section className="mb-16 text-center">
          <h1 className="mb-4 text-4xl font-extrabold text-gray-800">
            B.E.T.H AI Pricing Plans
          </h1>
          <p className="mb-8 text-gray-600">
            Choose the plan that best fits your needs and start automating your
            tasks with B.E.T.H.
          </p>
          <div className="flex flex-col items-stretch justify-center md:items-stretch md:flex-row md:space-x-8">
            {/* Basic Plan */}
            <div className="flex flex-col max-w-sm transition-transform hover:scale-105">
              <div className="bg-blue-400 h-2.5 rounded-t-md" />
              <div className="flex flex-col justify-between h-full p-8 bg-white shadow-md shadow-black/30 rounded-b-md">
                <div className="mb-12 space-y-8">
                  <h2 className="text-2xl font-bold text-blue-400">
                    Basic Plan
                  </h2>
                  <div className="flex flex-col gap-4">
                    <div className="flex gap-2.5 text-left text-customText-900 text-sm items-center">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>
                        Includes 5,000 tokens worth of B.E.T.H AI responses
                      </span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Provides basic, straightforward answers</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Basic Analysis</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-end justify-between mb-4">
                    <h1 className="text-3xl font-extrabold text-left text-customText-900">
                      $0
                    </h1>
                    <span className="mb-1 text-xs text-customSlate-900">
                      Token replenishes monthly
                    </span>
                  </div>
                  <Link to="/signup">
                    <button className="w-full py-2 font-bold bg-blue-400 rounded-md text-customText-100 hover:bg-blue-500">
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {/* Premium Plan*/}
            <div className="flex flex-col max-w-sm transition-transform hover:scale-105">
              <div className="bg-customGreen-700 h-2.5 rounded-t-md" />
              <div className="flex flex-col justify-between h-full p-8 bg-white shadow-md shadow-black/30 rounded-b-md">
                <div className="mb-12 space-y-8 ">
                  <h2 className="text-2xl font-bold text-customGreen-700">
                    Premium Plan
                  </h2>
                  <div className="flex flex-col gap-4">
                    <div className="flex gap-2.5 text-left text-customText-900 text-sm items-center">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Unlimited Tokens</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>File Analysis</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Delivers detailed and sophisticated answers</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>
                        Access to dedicated customer support with priority
                        response times
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-end gap-2 mb-4">
                    <h1 className="text-3xl font-extrabold text-left text-customText-900">
                      $16.99
                    </h1>
                    <span className="mb-1 text-xs text-customSlate-900">
                      per month
                    </span>
                  </div>
                  <Link to="/signup">
                    <button className="w-full py-2 font-bold rounded-md bg-customGreen-700 hover:bg-customGreen-800 text-customText-100">
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {/* ElecCoop Plan */}
            <div className="flex flex-col max-w-sm transition-transform hover:scale-105 ">
              <div className="bg-yellow-400 h-2.5 rounded-t-md" />
              <div className="flex flex-col h-full p-8 bg-white shadow-md shadow-black/30 justtify-between rounded-b-md ">
                <div className="mb-16 space-y-8">
                  <h2 className="text-2xl font-bold text-yellow-500">
                    Electric Cooperative Plan
                  </h2>
                  <div className="flex flex-col gap-4">
                    <div className="flex gap-2.5 text-left text-customText-900 text-sm items-center">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Unlimited Tokens</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Multiple File Upload</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>Improved accuracy in file analyzation</span>
                    </div>
                    <div className="flex gap-2.5 text-left text-sm items-center text-customText-900">
                      <Check
                        className="min-w-6"
                        strokeWidth={4}
                      />
                      <span>
                        Access to dedicated customer support with priority
                        response times
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-end gap-2 mb-4">
                    <h1 className="text-3xl font-extrabold text-left text-customText-900">
                      $99.99
                    </h1>
                    <span className="mb-1 text-xs text-customSlate-900">
                      per month
                    </span>
                  </div>
                  <Link to="/signup">
                    <button className="w-full py-2 font-bold bg-yellow-500 rounded-md hover:bg-yellow-600 text-customText-100">
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <p className="mt-6 text-gray-700 sm:w-auto ">
            1 token = ~4 characters in English, Input and Output
          </p>

          {/* Comparison Table */}
          <section className="mt-16">
            <hr className="my-8 border-t-2 border-gray-300" />
            <h2 className="mb-8 text-4xl font-bold">Feature Comparison</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-gray-800 border border-collapse border-gray-300 table-auto">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Feature
                    </th>
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Basic Plan
                    </th>
                    <th className="px-4 py-2 text-center border border-gray-300">
                      Premium Plan
                    </th>
                    <th className="px-2 py-2 text-center border border-gray-300">
                      Electric Coop Plan
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-2 border border-gray-300">
                      Chat Tokens
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      5,000
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      Unlimited
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      Unlimited
                    </td>
                  </tr>

                  <tr>
                    <td className="px-4 py-2 border border-gray-300">
                      GPT-4o mini
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                  </tr>
                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 border border-gray-300">GPT 4o</td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✖️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border border-gray-300">
                      File Upload Analysis
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✖️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                    <td className="px-4 py-2 text-center border border-gray-300">
                      ✔️
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <div className="mt-16 text-center">
            <hr className="my-8 border-t-2 border-gray-300" />
            <h2 className="mb-4 text-4xl font-bold">Give B.E.T.H a try</h2>
            <div className="flex justify-center">
              <p className="w-3/4 p-4 mb-8 text-lg text-gray-700">
                Sign up today and experience the future of financial assistance.
                Our AI-driven platform takes the complexity out of accounting,
                tax, and audit inquiries, so you can focus on what truly
                matters.
              </p>
            </div>
            <Link
              to="/signup"
              className="px-8 py-4 text-xl font-semibold text-white transition bg-green-500 rounded-lg hover:bg-green-600">
              Get Started →
            </Link>
          </div>

          <section className="p-8 mt-16 rounded-lg shadow-lg bg-gray-50">
            <h2 className="mb-2 text-4xl font-bold text-center">
              Frequently Asked Questions
            </h2>
            <hr className="my-6 border-t-2 border-gray-300" />

            <div className="mx-5 text-lg text-left text-gray-800">
              {[
                {
                  question: "What is B.E.T.H?",
                  answer:
                    "B.E.T.H is an AI Co-Pilot designed to assist you with various tasks by providing intelligent and detailed responses.",
                },
                {
                  question: "How do I start a conversation with the chatbot?",
                  answer:
                    'To start a conversation, simply type your question or message in the chat box and press "Enter." The chatbot will respond to your query in real-time. You can ask about a variety of topics, and the chatbot is designed to understand and reply to most common questions.',
                },
                {
                  question: "What are the benefits of the Premium Plan?",
                  answer:
                    "The Premium Plan offers unlimited tokens, file analysis, detailed and sophisticated answers, and priority customer support.",
                },
                {
                  question: "Is my data safe when using the chatbot?",
                  answer:
                    "Yes, your data is safe when using the chatbot. We use industry-standard encryption and data protection practices to ensure your information is secure.",
                },
                {
                  question: "Is there a free trial for the Premium Plan?",
                  answer:
                    "Currently, we do not offer a free trial for the Premium Plan, but you can start with the Basic Plan to get a feel for the services.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="mb-6">
                  <h3
                    onClick={() => toggleAccordion(index)}
                    className="flex items-center justify-between mb-2 text-2xl font-semibold cursor-pointer">
                    {item.question}
                    <span
                      className={`transform transition-transform ${
                        activeIndex === index ? "rotate-180" : ""
                      }`}>
                      ▼
                    </span>
                  </h3>
                  {activeIndex === index && (
                    <p className="mt-2 text-lg">{item.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </section>
        </section>
      </main>
      <Footer />
    </div>
  );
}
